import {
  CLERK_QUICK_SEARCH_QUERY,
  CLERK_QUICK_SEARCH_RECEIVE,
  CLERK_QUICK_SEARCH_RECEIVE_SUGGESTIONS,
  CLERK_QUICK_SEARCH_RECEIVE_CATEGORIES,
  CLERK_QUICK_SEARCH_RECEIVE_SORT_OPTIONS,
  CLERK_QUICK_SEARCH_SHOW_FULL_FORM,
  CLERK_QUICK_SEARCH_SELECT_ITEM,
  CLERK_QUICK_SEARCH_SET_SORTBY,
} from '../constants';

const DEFAULT_STATE = {
  query: '',
  sortBy: '',
  sortByOptions: [],
  result: null,
  suggestions: [],
  categories: [],
  showResult: false,
  showFullForm: false,
  selectedItem: -1,
};

export const clerk = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case CLERK_QUICK_SEARCH_QUERY:
    case CLERK_QUICK_SEARCH_RECEIVE:
    case CLERK_QUICK_SEARCH_RECEIVE_SUGGESTIONS:
    case CLERK_QUICK_SEARCH_RECEIVE_CATEGORIES:
    case CLERK_QUICK_SEARCH_SHOW_FULL_FORM:
    case CLERK_QUICK_SEARCH_SELECT_ITEM:
    case CLERK_QUICK_SEARCH_RECEIVE_SORT_OPTIONS:
    case CLERK_QUICK_SEARCH_SET_SORTBY:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
